// components/skeletons/FacilityCardSkeleton.tsx

import { Card, Col, Skeleton } from 'antd';

const CardSkeletonView = () => {
  return (
    <Col span={6}>
      <Card className='bh_card'>
        <Skeleton
          active
          paragraph={{ rows: 1 }}
          title={{ width: 80 }}
          avatar={{ size: 32, shape: 'circle' }}
        />
      </Card>
    </Col>
  );
};

export default CardSkeletonView;
